module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "nav1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["People with IBS"])},
        "nav2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HealthCare Professionnals"])},
        "notif": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🔔 Get Notified 🔔"])}
      },
      "fr": {
        "nav1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personnes avec SII"])},
        "nav2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professionnels de santé"])},
        "notif": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🔔 Soyez Notifiés 🔔"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"nav1":"People with IBS","nav2":"HealthCare Professionnals","notif":"🔔 Get Notified 🔔"},"fr":{"nav1":"Personnes avec SII","nav2":"Professionnels de santé","notif":"🔔 Soyez Notifiés 🔔"}}')
  delete Component.options._Ctor
  
}
